import ReactGA from 'react-ga4';

/**
 * GA4, gated behind cookie consent (see CookieConsent.tsx) and Consent Mode v2.
 * The `consent default` (denied) call lives in public/index.html and runs
 * before any tag can fire; `initGA` only ever runs after the visitor accepts,
 * at which point we flip the consent signal to granted and load the tag.
 */

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export const initGA = (): void => {
	if (initialized) return;
	if (!MEASUREMENT_ID) {
		console.debug('[GA4] No REACT_APP_GA_MEASUREMENT_ID configured — GA4 disabled.');
		return;
	}

	ReactGA.gtag('consent', 'update', { analytics_storage: 'granted' });
	ReactGA.initialize(MEASUREMENT_ID);
	initialized = true;

	trackPageView(window.location.pathname + window.location.search);
};

export const isGAInitialized = (): boolean => initialized;

export const trackPageView = (path: string): void => {
	if (!initialized) return;
	ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackGAEvent = (name: string, params?: Record<string, unknown>): void => {
	if (!initialized) return;
	ReactGA.event(name, params);
};
